const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const INTERNAL_LINK = new RegExp(`^#artifact=(${UUID})$`, 'i');
const LEGACY_REFERENCE = new RegExp(`\\[(${UUID})\\]`, 'gi');

export function artifactIdFromHref(href) {
  return INTERNAL_LINK.exec(href || '')?.[1].toLowerCase() || null;
}

function referenceParts(text, makeText, makeLink) {
  const result = [];
  let offset = 0;
  for (const match of text.matchAll(LEGACY_REFERENCE)) {
    if (match.index > offset) result.push(makeText(text.slice(offset, match.index)));
    result.push(makeLink(match[0], `#artifact=${match[1].toLowerCase()}`));
    offset = match.index + match[0].length;
  }
  if (offset < text.length) result.push(makeText(text.slice(offset)));
  return result;
}

// Work on parsed Markdown nodes: code, existing links and their URL targets
// must never be rewritten merely because they contain a bracketed UUID.
export function remarkArtifactReferences() {
  const visit = node => {
    if (!node.children || ['link', 'linkReference', 'image', 'imageReference'].includes(node.type)) return;
    node.children = node.children.flatMap(child => {
      if (child.type === 'text') {
        return referenceParts(child.value, value => ({ ...child, value }),
          (value, url) => ({ type: 'link', url, children: [{ type: 'text', value }] }));
      }
      visit(child);
      return [child];
    });
  };
  return visit;
}

export function setArtifactEditorContent(editor, markdown) {
  if (!editor) return;
  const visit = node => {
    if (node.type === 'codeBlock') return node;
    if (node.content) node.content = node.content.flatMap(child => {
      if (child.type === 'text' && !child.marks?.some(mark => ['code', 'link'].includes(mark.type))) {
        return referenceParts(child.text, text => ({ ...child, text }),
          (text, href) => ({ ...child, text, marks: [...(child.marks || []), { type: 'link', attrs: { href } }] }));
      }
      return [visit(child)];
    });
    return node;
  };
  editor.commands.setContent(visit(editor.markdown.parse(markdown)), { emitUpdate: false });
}
